const VerificationStatus = {
  Accepted: "accepted",
  Pending: "pending",
  Idle: "idle",
} as const;

type VerificationStatus =
  (typeof VerificationStatus)[keyof typeof VerificationStatus];

export default VerificationStatus;
